import { useEffect, useRef, useState } from 'react'
import { getCorrection } from '../api/dataCorrectionApi'

/**
 * The headers of the corrections a message names by id (the later ones of REVERT_LATER_CORRECTIONS_FIRST, the trim of
 * REVERT_CHILD_FIRST), so the screen can name them by worker, what and date: a correction id is never shown (PO 2026-10-17).
 * `known` are the headers already at hand (the page of the list); the others are asked once with GET dataCorrection/{id}.
 * Returns `headerOf(id)`, `undefined` while it is not known.
 */
export const useCorrectionLabels = (ids, known) => {
  const [asked, setAsked] = useState({})
  const pending = useRef(new Set())
  const aliveRef = useRef(false)
  useEffect(() => {
    aliveRef.current = true
    return () => { aliveRef.current = false }
  }, [])
  const missing = ids.filter((id) => !known[id] && !asked[id] && !pending.current.has(id))
  const missingKey = missing.join(',')
  useEffect(() => {
    missing.forEach((id) => {
      pending.current.add(id)
      getCorrection(id).then((header) => {
        if (aliveRef.current && header && header.id) setAsked((current) => ({ ...current, [id]: header }))
      }, () => {})
    })
  }, [missingKey]) // eslint-disable-line react-hooks/exhaustive-deps
  return (id) => known[id] || asked[id]
}
